import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'repairer-warning-banner',
  imports: [MatIconModule],
  host: {
    class:
      'flex justify-center items-center gap-x-15 h-60 fixed top-[55px] font-semibold! w-full z-10 body-1 text-dark-pink bg-light-pink'
  },
  template: `
    <mat-icon>info_outlined</mat-icon>
    <span class="max-w-[66vw]">{{ warning }}</span>
  `
})
export class RepairerWarningBanner {
  @Input({ required: true }) warning: string;
}
